// @ts-nocheck

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest, initialFetchListParams } from './index';
import { convertDataToServer as convertDataToServerVolume, convertDataFromServer as convertDataFromServerVolume } from './bioTreatmentFacilityVolume';
const convertDataToServer = bioTreatmentFacility => ({
  ...bioTreatmentFacility,
  volumes: bioTreatmentFacility?.volumes?.map(convertDataToServerVolume) ?? []
});
const convertDataFromServer = bioTreatmentFacility => ({
  ...bioTreatmentFacility,
  volumes: bioTreatmentFacility?.volumes?.map(convertDataFromServerVolume) ?? []
});
const baseUrl = 'bioTreatmentFacilityContract';
const bioTreatmentFacilityContract = new CommonApi(baseUrl, 'учет БОС', convertDataToServer, convertDataFromServer);
const list = async (params = initialFetchListParams) => {
  const list = await fetchRequest.get(`/${baseUrl}/list`, {
    ...initialFetchListParams,
    ...params
  });
  if (list) {
    return list;
  }
  throw new Error('Не удалось получить список');
};
const print = async filter => {
  const printed = await downloadRequestWithToken(`/${baseUrl}/print`, {
    ...filter
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};
const printYear = async year => {
  const printed = await downloadRequestWithToken(`/${baseUrl}/printYear`, { year });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};
const report = async (params = initialFetchListParams) => {
  const list = await fetchRequest.get(`/${baseUrl}/report`, {
    ...initialFetchListParams,
    ...params
  });
  if (list) {
    return list;
  }
  throw new Error('Не удалось получить список');
};
export default {
  ...bioTreatmentFacilityContract,
  print,
  list,
  printYear,
  report
};
